import { Grid } from 'antd';
import React from 'react'
import styled from 'styled-components'
import MainBanner from '../home/content/scope1/mainBanner';

const Banner = (props) => {
    const { orgUnitId } = props
    const { useBreakpoint } = Grid;
    const breakpoints = useBreakpoint();
    const Banner = styled.div`
        height: ${((breakpoints.xs || breakpoints.sm) && !breakpoints.lg) ? '313px' : '730px'};
    `
    return (
        <Banner className='div-banner'>
            <MainBanner orgUnitId={orgUnitId} />
        </Banner>
    )
}

export default Banner